{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Add Automation Rule",
    "LOADING": "Fetching automation rules",
    "ADD": {
      "TITLE": "Add Automation Rule",
      "SUBMIT": "Skapa",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Beskrivning",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "PHASE": {
          "LABEL": "Fas"
        },
        "ORDER": {
          "LABEL": "Ordning",
          "ERROR": "Ordning krävs"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Åtgärder"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Could not able to create a automation rule, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fas",
        "ORDER": "Ordning",
        "NAME": "Namn",
        "DESCRIPTION": "Beskrivning",
        "ACTIVE": "Active",
        "CREATED_ON": "Created on",
        "WAIT": "Väntetid"
      },
      "404": "No automation rules found",
      "TABS": {
        "ALL": "Alla",
        "INSTANT": "Vid händelse",
        "DELAYED": "Fördröjda"
      },
      "WAITS": "Väntar {duration}"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Radera",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "CONFIRM": {
        "TITLE": "Bekräfta borttagning",
        "MESSAGE": "Är du säker på att ta bort ",
        "YES": "Ja, ta bort ",
        "NO": "Nej, behåll "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Could not able to delete a automation rule, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Uppdatera",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Could not update automation rule, Please try again later"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Could not clone automation rule, Please try again later"
      }
    },
    "FORM": {
      "EDIT": "Redigera",
      "CREATE": "Skapa",
      "DELETE": "Radera",
      "CANCEL": "Avbryt",
      "RESET_MESSAGE": "Changing event type will reset the conditions and events you have added below"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "You need to have atleast one condition to save",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "You need to have atleast one action to save",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Välj e-postinkorg och avsändaradress",
      "SUBJECT_INPUT_PLACEHOLDER": "E-postens ämne",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Välj SMS-inkorgen som SMS:et ska skickas från",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Ange SMS-texten",
      "SMS_COUNTER": "{length}/{limit} tecken, {segments} SMS (innan variablerna fylls i)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "This action will activate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "DEACTIVATION_DESCRIPTION": "This action will deactivate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Could not Activate Automation, Please try again later",
      "DEACTIVATION_ERROR": "Could not Deactivate Automation, Please try again later",
      "CONFIRMATION_LABEL": "Ja",
      "CANCEL_LABEL": "Nej"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Could not upload attachment, Please try again",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Laddar upp...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Value is required",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Denna åtgärd fungerar bara när regelns fas är inställd på 'Före märkning'.",
      "SKIP_AUTO_LABELING": "Denna åtgärd fungerar bara när regelns fas är inställd på 'Före märkning'.",
      "MOVE_CONVERSATION_TO_INBOX": "Endast e-post- och webbchattkonversationer kan flyttas till en e-postinkorg, och en webbchatt bara om kontakten har en e-postadress. Annars stannar konversationen där den är och i stället läggs en privat anteckning till.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Startar en ny konversation med kontakten i den valda e-postinkorgen, skickar meddelandet till kontakten via e-post och markerar konversationen som löst. Det sker varje gång regeln körs. Om kontakten saknar e-postadress skickas ingenting och en privat anteckning läggs till i stället.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Startar en ny konversation med kontakten i den valda SMS-inkorgen, skickar meddelandet som SMS och markerar konversationen som löst. Det sker varje gång regeln körs. Meddelandet är ren text utan bilagor. Om kontakten saknar telefonnummer skickas ingenting och en privat anteckning läggs till i stället."
    },
    "NOTICES": {
      "AI_PROMPT": "Varje enskild utvärdering debiteras.",
      "INCOMING_MESSAGES_COUNT": "Detta avser antalet inkommande meddelanden i konversationen.",
      "OUTGOING_MESSAGES_COUNT": "Detta avser antalet utgående meddelanden i konversationen."
    },
    "PHASE": {
      "BEFORE_LABELING": "Före märkning",
      "AFTER_LABELING": "Efter märkning"
    },
    "NONE_OPTION": "Inget",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Inkommande meddelande",
      "OUTGOING": "Utgående meddelande",
      "PRIVATE": "Privat anteckning",
      "AI_SUMMARY": "AI-sammanfattning"
    },
    "YES_NO_VALUES": {
      "YES": "Ja",
      "NO": "Nej"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Direktmeddelande på Instagram",
      "FACEBOOK_COMMENT": "Facebook-kommentar"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Konversation skapad",
      "CONVERSATION_UPDATED": "Konversation uppdaterad",
      "MESSAGE_CREATED": "Meddelande skapat",
      "CONVERSATION_OPENED": "Konversation öppnad",
      "CONVERSATION_RESOLVED": "Konversation löst",
      "PHONE_CALL_FINISHED": "Samtal avslutat"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Tilldela agent",
      "ASSIGN_TEAM": "Tilldela ett team",
      "ADD_LABEL": "Lägg till en etikett",
      "REMOVE_LABEL": "Ta bort en etikett",
      "SEND_EMAIL_TO_TEAM": "Skicka e-post till team",
      "SEND_EMAIL_TRANSCRIPT": "Skicka en transkribering via e-post",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Skicka en detaljerad transkribering via e-post",
      "MUTE_CONVERSATION": "Tysta konversationen",
      "SNOOZE_CONVERSATION": "Snooza konversationen",
      "RESOLVE_CONVERSATION": "Lös konversationen",
      "OPEN_CONVERSATION": "Öppna konversationen",
      "SEND_WEBHOOK_EVENT": "Skicka webhook-händelse",
      "SEND_ATTACHMENT": "Skicka bilaga",
      "SEND_MESSAGE": "Skicka ett meddelande",
      "ADD_NOTE": "Lägg till en anteckning",
      "CHANGE_PRIORITY": "Ändra prioritet",
      "ADD_SLA": "Lägg till SLA",
      "SKIP_AUTO_PRIORITY": "Hoppa över automatisk prioritet",
      "SKIP_AUTO_LABELING": "Hoppa över automatisk märkning",
      "AUTO_TRANSLATE": "Översätt meddelande",
      "AUTO_TRANSLATE_CONVERSATION": "Översätt konversation",
      "MOVE_CONVERSATION_TO_INBOX": "Flytta konversation till inkorg",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Skicka meddelande i en ny konversation",
      "SEND_SMS_IN_NEW_CONVERSATION": "Skicka SMS i en ny konversation",
      "STOP_PROCESSING_RULES": "Sluta bearbeta regler"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI-filter",
      "MESSAGE_TYPE": "Meddelandetyp",
      "MESSAGE_CONTAINS": "Meddelandeinnehåll",
      "EMAIL": "E-post",
      "INBOX": "Inkorg",
      "CHANNEL_TYPE": "Inkorgstyp",
      "CONVERSATION_LANGUAGE": "Konversationsspråk",
      "PHONE_NUMBER": "Telefonnummer",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Webbläsarspråk",
      "MAIL_SUBJECT": "E-postämne",
      "COUNTRY_NAME": "Land",
      "MARKETPLACE_COUNTRY": "Marknadsplatsens land",
      "REFERER_LINK": "Referenslänk",
      "ASSIGNEE_NAME": "Tilldelad agent",
      "TEAM_NAME": "Team",
      "PRIORITY": "Prioritet",
      "CALL_DIRECTION": "Samtalsriktning",
      "MISSED_CALL": "Missat samtal",
      "MISSED_CALL_COUNT": "Antal missade samtal",
      "MESSAGE_SOURCE_TYPE": "Meddelandets källtyp",
      "INCOMING_MESSAGE_COUNT": "Antal inkommande meddelanden",
      "OUTGOING_MESSAGE_COUNT": "Antal utgående meddelanden",
      "LABEL": "Etikett",
      "EMAIL_RECIPIENTS": "E-postmottagare",
      "EMAIL_AUTO_REPLY": "E-post är ett automatiskt svar",
      "ATTACHMENT_EXTENSION": "Bilagans filändelse",
      "EXTENSION": "Uppringd anknytning",
      "WORKING_HOURS": "Inom öppettider",
      "AGENT_REPLIED": "Agent har svarat sedan statusändringen"
    },
    "WAIT": {
      "RUN_LABEL": "Kör åtgärderna",
      "INSTANT": "Vid händelse",
      "DELAYED": "Fördröjt",
      "TRIGGER_LABEL": "Vänta tills",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "En konversation stannar i en status",
        "CUSTOMER_UNRESPONSIVE": "Kunden svarar inte en agent",
        "AGENT_UNRESPONSIVE": "Kunden får inget svar från en agent"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Öppen",
        "PENDING": "Väntande",
        "SNOOZED": "Pausad",
        "RESOLVED": "Löst"
      },
      "DELAY_LABEL": "Väntetid",
      "DELAY_ERROR": "Ange en väntetid mellan 1 minut och 30 dagar",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} tim",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Åtgärderna körs när en konversation har haft statusen {status} i {duration}. En statusändring innan dess avbryter dem. Etiketter, öppettider och agentsvar kontrolleras när väntan är slut.",
        "CUSTOMER_UNRESPONSIVE": "Åtgärderna körs när kunden inte har svarat på en agents meddelande på {duration}. Ett svar från kunden avbryter dem; ett nytt meddelande från agenten startar om väntan.",
        "AGENT_UNRESPONSIVE": "Åtgärderna körs när kunden har väntat {duration} utan svar från en agent. Ett svar från agenten avbryter dem."
      }
    }
  }
}
